import { dataLayer } from "@repo/analytics/data-layer-utils";
import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
  dlCtaTextConstants,
} from "@repo/analytics/data-layer.constants";

export const handleInfoIconDL = (
  loginStatus: string,
  sectionTitle: string,
): void => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.SCRIP_FINANCIALS,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.ICON_CLICK,
    cta_text: dlElementConstants.OPEN_ICON,
    element: dlElementConstants.INFO_ICON,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.PDP_CLICKED,
    EP_ARTICLE_NAME: dlElementConstants.FINANCIALS,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};

export const handleCloseBtnDL = (
  loginStatus: string,
  sectionTitle: string,
  ctaText: string,
  btnClick = false,
): void => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.SCRIP_FINANCIALS,
    event: dlEventConstants.CLICK,
    event_type: btnClick
      ? dlEventConstants.BUTTON_CLICK
      : dlEventConstants.ICON_CLICK,
    element: btnClick
      ? dlElementConstants.SCRIP_FINANCIALS_BTN_CLICK
      : dlElementConstants.SCRIP_FINANCIALS_ICON_CLICK,
    cta_text: ctaText,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.PDP_CLICKED,
    EP_ARTICLE_NAME: dlElementConstants.FINANCIALS,
    EP_CTA: dlCtaTextConstants.CLOSE_ICON,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
